var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from 'react';
import { Button } from '@food/ui/build/dist/src/Button';
import { Field } from '@food/ui/build/dist/src/Field';
import { ErrorMessage } from '@food/ui/build/dist/src/ErrorMessage';
import { defaultMarginBottom, footer } from '../utils/theme';
import { validateEmail } from '../utils/misc';
import { registerClass, currySC, cns } from '@food/css-manager';
var style = registerClass(function (t, sc) { return "\n\t." + sc('input') + " > label {\n\t\tfont-size: " + t.ratios.l + "em;\n\t\tmargin-bottom: 0;\n\t}\n\t\n\t." + sc('strong') + " {\n\t\tfont-weight: " + t.font.weights.bold + ";\n\t}\n\t\n\t." + sc('error') + " {\n\t\tmargin-top: " + t.ratios.s * t.font.baseSize + "px;\n\t}\n"; });
var sc = currySC(style);
var hasErrors = function (errors, filters) {
    if (errors && errors.length) {
        return (errors.filter(function (e) {
            if (filters.context && filters.context === e.context) {
                return true;
            }
            if (filters.key && filters.key === e.key) {
                return true;
            }
            return filters.type && filters.type === e.type;
        }).length > 0);
    }
    return false;
};
export var InsertWorkEmail = function (_a) {
    var presetWorkEmail = _a.presetWorkEmail, t = _a.t, back = _a.back, errors = _a.errors, performRegister = _a.performRegister, supportEmail = _a.supportEmail;
    var _b = useState(presetWorkEmail || ''), email = _b[0], setEmail = _b[1];
    // il modo in cui il server mi suggerisce che devo inserire la work email e' un errore. Quindi e' come
    // se partissi gia' con un errore di validazione! Filtro questo errore poiche' non e' significativo per il
    // flusso di lavoro dell'utente
    var realErrors = errors
        ? errors.filter(function (e) { return e.type !== 'EMPTY_NOT_ALLOWED'; })
        : [];
    var message = React.createElement(ErrorMessage, { error: t('generic email error') });
    var errorState = hasErrors(realErrors, {
        key: 'options.workEmail',
    });
    // dati i possibili messaggi che mi restituisce il server devo scegliere quale messaggio visualizzare
    if (errorState) {
        var error = realErrors.filter(function (e) { return e.key === 'options.workEmail'; })[0];
        if (error.type === 'MUST_BE_UNIQUE') {
            message = (React.createElement(ErrorMessage, { error: t('alreadyUsedEmail error').replace('$SUPPORT_EMAIL', supportEmail) }));
        }
        else if (error.type === 'INVALID_VALUE') {
            message = React.createElement(ErrorMessage, { error: t('consumerOnlyEmail error') });
        }
        else if (error.type === 'UNSUPPORTED_FORMAT') {
            message = React.createElement(ErrorMessage, { error: t('wrongEmailFormat error') });
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Registration - Business Profile"], ["Registration - Business Profile"])))),
        React.createElement("section", { className: style },
            React.createElement("div", null, t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["We reserve specific functionalities to suppliers, buyers and food service operators so we have to be sure you work in the food business."], ["We reserve specific functionalities to suppliers, buyers and food service operators so we have to be sure you work in the food business."]))),
                React.createElement("br", null),
                React.createElement("span", { className: sc('strong') }, t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["We can't accept public email domains (@gmail.com, @aol.com, ...)"], ["We can't accept public email domains (@gmail.com, @aol.com, ...)"]))),
                    ". ", t(templateObject_4 || (templateObject_4 = __makeTemplateObject(["If your company doesn't have a private email domain"], ["If your company doesn't have a private email domain"]))),
                    ' ',
                    React.createElement("a", { href: "mailto:" + supportEmail }, t(templateObject_5 || (templateObject_5 = __makeTemplateObject(["contact us"], ["contact us"])))),
                    ".")),
            React.createElement(Field, { id: 'email', label: t(templateObject_6 || (templateObject_6 = __makeTemplateObject(["Insert your job email address"], ["Insert your job email address"]))), error: errorState, className: sc('input') },
                React.createElement("input", { id: "email", type: "email", onChange: function (event) { return setEmail(event.target.value); }, value: email }),
                email && email.length && errorState && (React.createElement("div", { className: cns(defaultMarginBottom, sc('error')) }, message))),
            React.createElement("div", { className: footer },
                React.createElement(Button, { label: t(templateObject_7 || (templateObject_7 = __makeTemplateObject(["Back"], ["Back"]))), onClick: back }),
                React.createElement(Button, { label: t(templateObject_8 || (templateObject_8 = __makeTemplateObject(["Continue"], ["Continue"]))), type: 'success', disabled: !validateEmail(email), onClick: function () { return performRegister(email); } })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=InsertWorkEmail.js.map